<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="80%" :before-close="handleClose"
		:close-on-click-modal="false">
		<el-form label-position="right" ref="addForm" :model="addForm" label-width="70px" class="postForm">
			<el-form-item label="所属年级:" label-width="110px" class="notBlank">
				<el-select v-model="addForm.gradeId" placeholder="请选择" size="small" class="formItem250">
							<el-option v-for="item in gradeDict" :key="item.id" :label="item.gradeName"
								:value="item.id">
							</el-option>
						</el-select>
			</el-form-item>
			<el-form-item label="教材版本:" label-width="110px" class="notBlank">
			<el-select v-model="addForm.bookVersionId" placeholder="请选择" size="small" class="formItem250">
							<el-option v-for="item in bookVersionDict" :key="item.valuekey" :label="item.textkey"
								:value="item.valuekey">
							</el-option>
						</el-select>
			</el-form-item>
			<el-form-item label="赛季:" label-width="110px" class="notBlank">
						<el-select v-model="addForm.seasonId" placeholder="请选择" size="small" class="formItem250">
							<el-option v-for="item in seasonDict" :key="item.id" :label="item.seasonName"
								:value="item.id">
							</el-option>
						</el-select>
			</el-form-item>
			<el-form-item label="排位赛名称:" label-width="110px" class="notBlank">
				<el-input v-model="addForm.matchName" auto-complete="off" class="formItem300" size="small"
					maxLength="100" />
			</el-form-item>
			<el-form-item label="总分数:" label-width="110px">
				<el-input v-model="addForm.scoreNum" auto-complete="off" class="formItem150" size="small" maxLength="50"
					disabled />
			</el-form-item>
			<el-form-item label="开始日期:" label-width="110px" class="notBlank">
				<el-date-picker type="date" v-model="addForm.startDate" value-format="yyyy-MM-dd" size="small"
					class="formItem"></el-date-picker>
			</el-form-item>
			<el-form-item label="结束日期:" label-width="110px" class="notBlank">
				<el-date-picker type="date" v-model="addForm.endDate" value-format="yyyy-MM-dd" size="small"
					class="formItem"></el-date-picker>
			</el-form-item>

			<el-form-item label="状态:" label-width="100px">
				<el-select v-model="addForm.status" placeholder="请选择" size="small" class="formItem">
					<el-option v-for="item in proStatusDict" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="描述:" label-width="110px">
				<el-input v-model="addForm.matchRemark" type="textarea" :rows="4" style="width: 450px;"
					auto-complete="off" size="small" class="formItem" />
			</el-form-item>
			<!-- <el-form-item label="题目维护:" label-width="150px" class="notBlank">
				</el-form-item> -->
		</el-form>
		<div style="background-color: #F8F8F9;padding: 5px;margin-top:5px">
			<el-button type="primary" icon="el-icon-circle-plus-outline" plain size="mini"
				@click="() => { dialogSelectVisible = true }">题库选择</el-button>
			<!-- <el-button type="primary" icon="el-icon-circle-plus-outline" plain size="mini"
				@click="handleAdd">新增题目</el-button> -->
		</div>
		<div>
			<el-table :data="detailList" height="400px" border highlight-current-row style="width: 100%;"
				:header-cell-style="{ height: '30px' }">
				<el-table-column type="index" width="55" label="序号"></el-table-column>
				<el-table-column prop="proTypeName" label="题目类型" width="80"></el-table-column>
				<el-table-column prop="proNo" label="题号" width="80"></el-table-column>
				<el-table-column prop="proName" label="题目" width="250" show-overflow-tooltip></el-table-column>
				<el-table-column prop="proLevelName" label="难度" width="80"></el-table-column>
				<el-table-column prop="scoreNum" label="分值" width="75">
					<template scope="scope">
                        <el-input v-model="scope.row.scoreNum" auto-complete="off" size="small" maxLength="3"  @change="calScore"/>
                    </template>
				</el-table-column>
				<el-table-column prop="gradeName" label="年级" width="100" show-overflow-tooltip></el-table-column>
				<el-table-column prop="unitName" label="单元" width="100" show-overflow-tooltip></el-table-column>
				<el-table-column prop="chapterName" label="章节" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column label="操作" min-width="100">
					<template scope="scope">
						<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="handleSubmit()" size="small">确 定</el-button>
		</div>
		<el-dialog title="选择题库" :visible.sync="dialogSelectVisible" width="880px" append-to-body>
			<select_exercise :options="{ disabled: false, clearable: true, width: '100%',show:dialogAddShow }" @callBack="selCallBack">
			</select_exercise>
		</el-dialog>

	</el-dialog>
</template>
<script>

import select_exercise from '@/components/select_exercise.vue'
export default {
	name: "addSave",
	props: ["showTitle", "dialogAddShow", "mid"],
	components: { select_exercise },
	data() {
		return {
			addForm: {
				id: 0,
				matchName: '',
				scoreNum: 0,
				matchRemark: '',
				status: 1,
				addTime: "",
				startDate:'',
				endDate:'',
				gradeId:'',
				bookVersionId:'',
				seasonId:'',
			},
			detailList: [],
			dialogSelectVisible: false,
			webConfig: {},
			bookVersionDict:[],
			gradeDict:[],
			seasonDict:[]
		};
	},
	watch: {
		dialogAddShow: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.initData();
				}
			},
			deep: true
		}
	},
	methods: {
		initWebConfig() {
			this.$axios
				.get(
					"/basic/getwebconfigsetinfo?id=" + this.mid + "&rnd=" + new Date().getTime()
				)
				.then((res) => {
					this.webConfig = res.data.data
				});
		},
		async loadSeason() {
			let formData = this.$util.jsonToForm({
				seasonName: '',
				rows: 1000,
				page: 1
			});
			this.$axios.post("/exercise/getrankmatchseasonlist", formData).then(res => {
				this.seasonDict = res.data.data;
			});
		},
		delInfo(index, row) {
			this.detailList.splice(index, 1)
			this.calScore()
		},
		selCallBack(rows) {
			rows.map(v => {
				if (this.detailList.filter(v1 => v1.proId == v.id).length == 0) {
					v.proRemark = ""
					v.proAnalysis = ""
					this.detailList.push({ ...v, proId: v.id,scoreNum:Number(this.webConfig['levelScoreType' + v.proLevel]) })
				}
			})
			this.calScore()
			this.dialogSelectVisible = false
		},
		saveCallBack(id) {
			this.$axios.get("/exercise/getexerciseinfoinfo?id=" + id + "&rnd=" + new Date().getTime())
				.then(res => {
					let v = res.data.data
					if (this.detailList.filter(v1 => v1.proId == v.id).length == 0) {
						v.proRemark = ""
						v.proAnalysis = ""
						this.detailList.push({ ...v, proId: v.id })
					}
					this.calScore()
				})
			this.dialogAddShow2 = false
		},
		initData() {
			this.detailList = []
			this.$axios.get("/exercise/getrankmatchinfo?id=" + this.mid + "&rnd=" + new Date().getTime())
				.then(res => {
					this.addForm = res.data.data;
					if (this.addForm.id <= 0) {
						this.addForm = {
							id: 0,
							matchName: '',
							scoreNum: 0,
							matchRemark: '',
							status: 1,
							addTime: "",
							startDate:'',
							endDate:'',
							gradeId:'',
							bookVersionId:'',
							seasonId:'',
						}
					}
					else {
						this.detailList = [...this.addForm.detailList]
					}
				});
		},
		calScore() {
			let scoreNum = 0
			this.detailList.map(v => {
				scoreNum += Number(v.scoreNum)
			})
			this.addForm.scoreNum = scoreNum
		},
		handleClose() {
			this.$emit("getVisible", false);
		},
		handleSubmit() {
			this.addForm.detailList = [...this.detailList]
			let formData = this.$util.jsonToForm(this.addForm);
			this.$axios.post("/exercise/rankmatchsave", formData).then(res => {
				if (res.data.status == 0) {
					this.$message("保存成功!");
					this.$emit("saveCallBack");
				} else {
					this.$message(res.data.msg);
				}
			});
		},
		handleAdd() {
			this.$emit("addExercise", true);
		}
	},
	async created() {
		this.initWebConfig()
		this.gradeDict=await this.loadGrade()
		await this.loadSeason()
		this.bookVersionDict = (await this.getDictInfo('bookVersion'))
	}
};
</script>

<style lang="less" scoped></style>
